import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import timeLine from '@blade-sxp/device-management-pass/components/time-line.vue';
import { ruleDetails, putRuleDeploy } from '@blade-sxp/device-management-pass/api/index';
import moment from 'moment';
import langMsg from '@blade-sxp/device-management-pass/lang/index';
let default_1 = class extends Vue {
    userType = '';
    formList = ['sundayPeriod', 'mondayPeriod', 'tuesdayPeriod', 'wednesdayPeriod', 'thursdayPeriod', 'fridayPeriod', 'saturdayPeriod'];
    timeLineVal = {
        sundayPeriod: '',
        mondayPeriod: '',
        tuesdayPeriod: '',
        wednesdayPeriod: '',
        thursdayPeriod: '',
        fridayPeriod: '',
        saturdayPeriod: '',
        holidayPeriod: '',
    };
    timeLinechecke = {
        sundayPeriod: false,
        mondayPeriod: false,
        tuesdayPeriod: false,
        wednesdayPeriod: false,
        thursdayPeriod: false,
        fridayPeriod: false,
        saturdayPeriod: false,
        holidayPeriod: false,
    };
    paste = [
        {
            startTime: '00:00',
            endTime: '00:00',
            startPercent: 0,
            endPercent: 0,
            momentTime: [new Date('1970-1-1 00:00'), new Date('1970-1-1 00:00')],
        },
    ];
    validityPeriod = '';
    holidayTimeList = [];
    _holidayPeriod;
    repeatOptions = [
        { value: true, label: this.$t('yes') },
        { value: false, label: this.$t('no') },
    ];
    staticTimes = {
        endTime: '2099-01-01 23:59:59',
        startTime: '2000-01-01 00:00:00',
        startHour: '00:00:00',
        endHour: '23:59:59',
    };
    form = {
        name: '',
        startTime: '',
        endTime: '',
        sundayPeriod: [],
        mondayPeriod: [],
        tuesdayPeriod: [],
        wednesdayPeriod: [],
        thursdayPeriod: [],
        fridayPeriod: [],
        saturdayPeriod: [],
        holidayPeriod: [],
        deviceId: 0,
        specialDays: [],
        portraitLibId: 0,
    };
    libName = '';
    isForever = false;
    accountRules = {
        endTime: [{ required: true, message: this.$t('noValidityPeriod'), trigger: 'change' }],
    };
    isAddTime = false;
    get curType() {
        return this.$t(this.userType);
    }
    mounted() { }
    changeAllTime(val, type) {
        let str = [];
        for (let i = 0; i < 48; i++) {
            if (val) {
                str.push(1);
            }
            else {
                str.push(0);
            }
        }
        this.timeLineVal[type] = str.join('');
    }
    handleChange(time, type) {
        this.getTimeArr(time, type);
    }
    getTimeArr(time, type) {
        let arr = [];
        time?.[0]?.times.forEach((it) => {
            let toTime = it.to;
            if (toTime === '24:00') {
                toTime = this.staticTimes.endHour;
            }
            else {
                toTime = `${it.to}:00`;
            }
            let obj = { startTime: `${it.from}:00`, endTime: toTime };
            arr.push(obj);
        });
        this.form[type] = arr;
    }
    updateValidityPeriod() {
        const date = this.validityPeriod;
        this.form.startTime = `${this.formatDate(date[0])} ${this.staticTimes.startHour}`;
        this.form.endTime = `${this.formatDate(date[1])} ${this.staticTimes.endHour}`;
        if (this.isForever) {
            this.isForever = false;
        }
    }
    setForever() {
        if (this.isForever) {
            this.validityPeriod = '';
            this.form.startTime = this.staticTimes.startTime;
            this.form.endTime = this.staticTimes.endTime;
        }
        else if (this.validityPeriod === '') {
            this.form.startTime = '';
            this.form.endTime = '';
        }
    }
    initTimeVal(arr, key) {
        let newVal = [];
        for (let i = 0; i < 48; i++) {
            newVal.push(0);
        }
        arr &&
            arr.forEach((it) => {
                let start = moment.duration(it.startTime)?._milliseconds / 1800000;
                let end = moment.duration(it.endTime)?._milliseconds / 1800000;
                for (let i = start; i < end; i++) {
                    newVal[i] = 1;
                }
            });
        this.timeLineVal[key] = newVal.join('');
    }
    checkedAllTime(time, type) {
        if (time.length && time?.[0]?.startTime === this.staticTimes.startHour && time?.[0]?.endTime === this.staticTimes.endHour) {
            this.timeLinechecke[type] = true;
        }
        else {
            this.timeLinechecke[type] = false;
        }
    }
    analysisData(data) {
        Object.keys(this.timeLineVal).forEach((key) => {
            this.form[key] = data[key];
            this.initTimeVal(data[key], key);
            this.checkedAllTime(data[key], key);
        });
    }
    created() {
        const { deviceId, libId, libName, type } = this.$route.query;
        this.userType = String(type);
        this.form.deviceId = Number(deviceId);
        this.form.portraitLibId = Number(libId);
        this.libName = String(libName);
        // 编辑模式下获取列表数据
        this._holidayPeriod = [];
        ruleDetails({ deviceId: this.form.deviceId, portraitLibId: this.form.portraitLibId }).then((res) => {
            if (res.timetable) {
                const data = res.timetable;
                this.analysisData(data);
                if (data.endTime === this.staticTimes.endTime) {
                    this.isForever = true;
                    this.validityPeriod = [];
                    this.form.startTime = this.staticTimes.startTime;
                    this.form.endTime = this.staticTimes.endTime;
                }
                else {
                    this.validityPeriod = [new Date(data.startTime), new Date(data.endTime)];
                    this.form.startTime = data.startTime;
                    this.form.endTime = data.endTime;
                }
                this.form.name = data.name;
                if (data?.specialDays?.length) {
                    for (let item of data.specialDays) {
                        const { startDate, name, repeat } = item;
                        const date = [new Date(startDate)];
                        this._holidayPeriod.push({
                            name,
                            repeat,
                            date,
                            isRead: true,
                        });
                    }
                    this.onChangeHolidayPeriod(this._holidayPeriod);
                }
            }
        });
    }
    formatDate(date) {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${date.getFullYear()}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    }
    getDateStr(i) {
        const target = this._holidayPeriod[i].date;
        if (target?.[0]) {
            let result = this.formatDate(target?.[0]);
            return result;
        }
    }
    handleEditHoliday(i) {
        const target = this._holidayPeriod[i];
        if (target?.date?.[0]) {
            target.isRead = false;
            target.draft = {
                name: target.name,
                date: [new Date(target?.date?.[0].valueOf())],
                repeat: target.repeat,
            };
        }
        this.onChangeHolidayPeriod(this._holidayPeriod);
    }
    handleDeleteHoliday(i) {
        this._holidayPeriod.splice(i, 1);
        this.onChangeHolidayPeriod(this._holidayPeriod);
    }
    handleFinishHoliday(i) {
        const target = this._holidayPeriod[i];
        if (target.name && target.date && target.repeat !== '') {
            delete target.draft;
            target.isRead = true;
        }
        else {
            this.$message.error(this.$t('paramError').toString());
        }
        this.onChangeHolidayPeriod(this._holidayPeriod);
    }
    handleCancelHoliday(i) {
        const target = this._holidayPeriod[i];
        if (target.name && target?.draft) {
            target.name = target?.draft?.name;
            target.date = target.draft.date;
            target.repeat = target.draft.repeat;
            target.isRead = true;
            delete target.draft;
        }
        else {
            this._holidayPeriod.splice(i, 1);
        }
        this.onChangeHolidayPeriod(this._holidayPeriod);
    }
    handleAddHoliday() {
        this._holidayPeriod.push({
            isRead: false,
            name: '',
            date: [],
            repeat: '',
        });
        this.onChangeHolidayPeriod(this._holidayPeriod);
    }
    handleCancel() {
        this.$router.push({ path: '/setting/deviceManagementPass/detail', query: { deviceId: String(this.form.deviceId) } });
    }
    handleSubmit(formName) {
        this.form.specialDays = [];
        let specialDaysFlag = true;
        let valueAlreadlySeen = [];
        this._holidayPeriod.forEach((it, idx) => {
            let obj = {
                startDate: it?.date?.[0] ? moment(it?.date?.[0]).format('YYYY-MM-DD') : '',
                repeat: it?.repeat,
                name: it.name,
            };
            const timeValue = moment(it?.date?.[0]).format('YYYY-MM-DD');
            valueAlreadlySeen.push(timeValue);
            if (obj.repeat === '' || !obj.name) {
                specialDaysFlag = false;
            }
            this.form.specialDays.push(obj);
        });
        const isRepeat = valueAlreadlySeen.some((x, index, arr) => arr.findIndex((y) => y === x) !== index);
        if (isRepeat) {
            this.$message.error(this.$t('timeRepeated').toString());
            return;
        }
        if (!specialDaysFlag) {
            this.$message.error(this.$t('paramError').toString());
            return;
        }
        this.$refs[formName].validate((valid) => {
            // if (!this.validityPeriod && this.form.endTime) {
            //   this.validityPeriod = [new Date(), new Date()];
            // }
            if (valid) {
                putRuleDeploy(this.form).then((res) => {
                    this.$message({
                        message: this.$t('common.toolSuccess').toString(),
                        type: 'success',
                    });
                    this.$router.push({ path: '/setting/deviceManagementPass/detail', query: { deviceId: String(this.form.deviceId) } });
                });
                // .catch((err) => {
                //   this.$message.error({ message: err, type: 'error' });
                // });
            }
            else {
                this.$message.error(this.$t('paramError').toString());
                return false;
            }
        });
    }
    onChangeHolidayPeriod(val) {
        if (val) {
            this.isAddTime = val.length >= 10;
        }
        else {
            this.isAddTime = false;
        }
    }
};
default_1 = __decorate([
    Component({
        components: {
            timeLine,
        },
        i18n: {
            sharedMessages: langMsg,
            messages: {
                zh: {
                    passageTimetable: '通行时刻表',
                },
                en: {
                    passageTimetable: 'Passage Timetable',
                },
            },
        },
    })
], default_1);
export default default_1;
